import React, { useState, useEffect } from 'react'

import {
    Button,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
} from "@material-ui/core";
import { DatePicker } from '@material-ui/pickers';

import { gql, useApolloClient } from '@apollo/client';
import { useDispatch } from 'react-redux';

import { AddBPMApplicationMessages } from '../../../redux/reducers/BPMReducer';
import BPMDialog from '../../../components/BPMTable/TableComponents/Dialogs/BPMDialog';
import { getTodayDateString, parsePlainDate, toPlainDateString } from '../../../utils/DateUtils';

const REIMBURSED = gql`
    mutation(
        $id: String!, 
        $concurTicket: String!,
        $claimedAmount: String!,
        $approvedAmount: String!,
        $closedAt: Date!,
    ){
    bayphoneReimbursed(
            id:$id, 
            concurTicket: $concurTicket,
            claimedAmount: $claimedAmount,
            approvedAmount: $approvedAmount,
            closedAt: $closedAt,
    ) {
      bayphone {
        id
      }
    }
  }
`;


const BayphoneReimbursedDialog = props => {
  const [isLoading, setLoading] = useState(false);
  const [concurTicket, setConcurTicket] = useState('');
  const [claimedAmount, setClaimedAmount] = useState(null);
  const [approvedAmount, setApprovedAmount] = useState(null);
  const [closedAt, setClosedAt] = useState(getTodayDateString());


  const { open, handleClose, selectedRows, t } = props;

    const dispatch = useDispatch()
    const client = useApolloClient()

  useEffect(() => {
    return () => {
      setLoading(false);
      setConcurTicket('');
      setClaimedAmount(null);
      setApprovedAmount(null);
      setClosedAt(getTodayDateString());
    };
  }, []);

  const onClickProcess = () => {
        setLoading(true)

        client.mutate({
        mutation: REIMBURSED,
        variables: {
          id: selectedRows[0].id,
          concurTicket: concurTicket,
          claimedAmount: claimedAmount,
          approvedAmount: approvedAmount,
          closedAt: closedAt,
        },
      })
      .then(result => {
        const success = result.data;

        if (success) {
                handleQueryExecuted(true, t("State change successfully executed"));
            } else {;
          handleQueryExecuted(false, t('An error occurred while changing the state of the Bayphone'));
        }
      })
      .catch(error => {
            handleQueryExecuted(false, JSON.stringify(error))
        })
        .finally(() => {
          setLoading(false);
        });
  };

  const createApplicationMessage = (text, variant) => {
        dispatch(AddBPMApplicationMessages({
        text: text,
        duration: 8000,
        variant: variant,
        }))
    }

  const handleQueryExecuted = (success, message) => {
    createApplicationMessage(message, success ? 'success' : 'error');
    setLoading(false);
    onCloseDialog();
    }

  const onCloseDialog = () => {
    setConcurTicket('');
    setClaimedAmount(null);
    setApprovedAmount(null);
    setClosedAt(getTodayDateString());
    handleClose();
    }

  const submitable = () => {
        return (concurTicket) && (claimedAmount) && (approvedAmount) && (closedAt) && (isLoading === false)
    }

  const handleClosedAtChange = date => {
    setClosedAt(toPlainDateString(date) || '');
  };

  const closedAtDate = closedAt ? parsePlainDate(closedAt) : null;

  return (
    <BPMDialog
      open={open}
      onClose={onCloseDialog}
        maxWidth='md'
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
    >
            <DialogTitle id='alert-dialog-title'>
                <span onClick={(event, reason) => onCloseDialog(event, reason)} style={{fontSize: '1.5em',  cursor: 'pointer', position: 'absolute', right: '5px', top: '-5px'}}>&times;</span>
        {t('bayphone:Bayphone')}
      </DialogTitle>
      <DialogContent>
        <TextField
          label={t('bayphone:Concur ticket')}
                    variant='outlined'
          value={concurTicket}
          onChange={e => setConcurTicket(e.target.value)}
          style={{ marginTop: 10, marginBottom: 10, width: '100%' }}
        />
        <TextField
          label={t('bayphone:Claimed Amount')}
                    variant='outlined'
          value={claimedAmount}
          onChange={e => setClaimedAmount(e.target.value)}
          style={{ marginTop: 10, marginBottom: 10, width: '100%' }}
        />
        <TextField
          label={t('bayphone:Approved Amount')}
                    variant='outlined'
          value={approvedAmount}
          onChange={e => setApprovedAmount(e.target.value)}
          style={{ marginTop: 10, marginBottom: 10, width: '100%' }}
        />
        <DatePicker
          label={t('bayphone:Closed at')}
          value={closedAtDate}
          onChange={handleClosedAtChange}
          inputVariant='outlined'
          format='P'
          style={{ width: 250, marginTop: 10, marginBottom: 10 }}
        />
                
      </DialogContent>
      <DialogActions style={{ justifyContent: 'space-between' }}>
        <div>
                    <Button 
                        style={{ marginRight: 20 }}
                        onClick={onCloseDialog} 
                        variant='contained'
                        disabled={isLoading}
                    >
            {t('bayphone:Cancel')}
          </Button>
                    <Button
                        onClick={onClickProcess}
                        variant='contained'
                        color='primary'
                        disabled={!submitable()}
                    >
            {t('bayphone:Reimbursed')}
          </Button>
        </div>
      </DialogActions>
    </BPMDialog>
    )
};

export default BayphoneReimbursedDialog;
